define('rebrush/components/blocks/catalogsearch/autocomplete/recommendations',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({

        searchBlock: null,
        recommendationsBlock: null,
        $document: $(document.body),
        minQueryLength: null,

        $init: function() {
            this.searchBlock = BEM.block('header-search');
            this.recommendationsBlock = BEM.block('search-autocomplete-recommendations');

            this.minQueryLength = typeof gigaset !== 'undefined' && gigaset.catalogsearch.config.min_query_length ? gigaset.catalogsearch.config.min_query_length : 2;

            this.initializeEvents();
        },

        initializeEvents: function() {
            var searchInput = this.searchBlock.getElements('input').first();

            // this.searchBlock.getElements('input').first().on(['input', 'focus'], _.bind(this.onSearchInput, this));

            ['input','focus'].forEach(event =>
                searchInput.on(event, _.bind(this.onSearchInput, this))
            );
        },

        onSearchInput: function(e) {
            var input = e.currentTarget;

            if (input.value.length >= this.minQueryLength) {
                if (!this.recommendationsBlock.hasModifier('hidden')) {
                    this.recommendationsBlock.addModifier('hidden');
                }
            } else {
                if (this.recommendationsBlock.hasModifier('hidden')) {
                    this.recommendationsBlock.removeModifier('hidden');
                }
            }
        }

    });
});
